exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-b91fc774]{\n  max-height: 80vh !important;\n  overflow: auto !important;\n}\n", ""]);

// exports
